module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"言語設定"},"en":{"title":"Language Setting"}}')
  delete Component.options._Ctor
}
